import {
	USER,
} from '../constants';

const initialState = {
	fetchingState: USER.NONE,
	recipes: [],
	profile:null,
	error : null
};

export default function(state = initialState, action){
	switch(action.type) {

	case USER.FETCHING:
	case USER.NONE:
		return {
			...state,
			fetchingState:action.type,
		};
	case USER.RECIPE_LOADED:
	case USER.PROF_LOADED:
		return {
			...state,
			fetchingState:action.type,
			...action.payload
		};
	
	default:
		return state;
	}
}